import { ProductType } from "../../../../packages/ts-interfaces";

// Can a material from the sidebar (or the roughness/metalness sliders) be
// applied to this board object? Transcribed from the object branch of
// PropertyControllerContainer.isObjectEditable so the single-object inspector
// and the bulk (multi-select) paths share one rule. Three-free.
export function isMaterialEditable(physicalObject: any): boolean {
  if (!physicalObject) return false;
  if (physicalObject.type === ProductType.PAINT) return false; // paint objects take paint, via their own picker
  if (physicalObject.isStaticObject === true) return false;
  if (physicalObject.type === "dynamic" && physicalObject.mode === "material") return false;
  if (
    physicalObject.isStaticObject === false ||
    physicalObject.type === "not_static" ||
    physicalObject.type === "Shape"
  )
    return true;
  return false;
}
